(function () {
  'use strict';FunnelController.$inject = ["Funnel"];

  angular.
  module('gplans.layout.controllers').
  controller('FunnelController', FunnelController);

  FunnelController.$inject = [
  'Funnel'];


  function FunnelController(
  Funnel)
  {

    activate();

    function activate() {
      var step = Funnel.getStep();
      Funnel.redirect(step);
    }
  }
})();